<template lang="pug">
.row(:style="rowStyle" :class="{'has-title-tip': isTruncated}")
  .single(@click="handleClick()")
    .cntnt(@mouseenter="checkTruncation")
      .spacer(v-for="n in node.level")
      a.is-link.fas.fa-angle-up(v-if="node.hasChildren" :class="{'expanded': node.expanded, 'expander': node.parent, 'button': !node.parent}")
      .phase(v-if="!node.hasChildren" :class="{out: node.index < node.maxIndex, in: node.index > 0}") {{node.index + 1}}
      span(v-if="node.class" :class="node.class")
      span.row-title(ref="rowTitle") {{node.title}}
    .row-tip(v-if="isTruncated") {{node.title}}
    .columns.topped
      .column.is-offset-one-quarter.cells
        transition-group(name="fade" tag="div")
          Cell(v-for="c in cols" :col="c" :key="c.key" @click.stop="handleCellClick(c)")
        .no-goals-info(v-if="!hasAnyDescendantGoals && node.hasChildren && node.parent")
          span de leerdoelen in dit thema worden nog toegevoegd
        
  transition(name="expand")
    .children(v-if="(node.hasChildren && node.expanded) || !node.parent")
      Row(v-for="c in filteredChildren" :node="c" :target="target" @click="handleRowClick")
</template>

<script>
import Cell from './Cell.vue'
import Chroma from 'chroma-js'

export default {
  props: ['node', 'target'],
  data() {
    return {
      expanded55: true,
      isTruncated: false
    }
  },
  computed: {
    cols() {
      return this.findCols()
    },
    hasAnyDescendantGoals() {
      const collectTags = (n) => {
        let tags = [].concat(n.tags || [])
        if (n.children) {
          _.each(n.children, (c) => { tags = tags.concat(collectTags(c)) })
        }
        return tags
      }
      const allTags = _.uniq(collectTags(this.node))
      return _.some(allTags, (tag) => _.find(this.target.rows, (row) => row.key === tag || row.code === tag))
    },
    phaseColor() {
      let scale = Chroma.scale(['#b8b3ad', '#7a756f'])
      return scale(1.0 * this.node.index / this.node.maxIndex)
    },
    
    rowStyle() {
      return {
        'border-top-color': (this.node.level == this.node.maxLevel - 1) ?  '#aaa' : ''
      }
    },
    filteredChildren() {
      const descendants = (g) => {
        return [g].concat(g.hasChildren ? _.flatten(_.map(g.children, descendants)) : [])
      }

      //is any goal under goal active?
      const activeGoals = _.filter(this.target.rows, (d) => d.active)
      if (activeGoals.length == 0) {
        return this.node.children //no filter
      } else {
        //only those children that have a tag that is set to active
        //or have a child that has it
        //active tags even tags that are children tags of them
        const activeDescendants = _.flatten(_.map(activeGoals, descendants))
        const activeTags = _.flatten(_.map(activeDescendants, 'key').concat(_.map(activeDescendants, 'code')))
        const descendantTags = _.map(descendants(this.node), 'tags')
        return _.filter(this.node.children, (c) => {
          const descendantTags = _.flatten(_.map(descendants(c), 'tags'))

          const fs = _.filter(descendantTags, (t) => activeTags.indexOf(t) > -1)
          return fs.length > 0
        })
      }
    }
  },
  name: 'Row',
  components: {Cell},
  mounted() {
    this.checkTruncation()
    window.addEventListener('resize', this.checkTruncation)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkTruncation)
  },
  updated() {
    this.checkTruncation()
  },
  methods: {
    checkTruncation() {
      const measure = () => {
        const t = this.$refs.rowTitle
        const next = !!(t && t.scrollWidth > t.clientWidth + 1)
        if (next !== this.isTruncated) {
          this.isTruncated = next
        }
      }
      measure()
      this.$nextTick(measure)
    },
    handleClick() {
      if (!this.node.parent) {
        //top level click means expand its children
        _.each(this.node.children, (c) => {
          c.expanded = !this.node.expanded
        })
      }
      //also do this for top level
      if (this.node.hasChildren) {
        this.node.expanded = !this.node.expanded
      } else {
        this.$emit('click', {
          row: this.node
        })
      }
    },
    handleRowClick(data) {
      this.$emit('click', data)
    },
    handleCellClick(cell) {
      console.log('clickyclack on ', cell)
      this.$emit('click', {
        row: this.node,
        cell: cell
      })
    },
    findCols() {
      let cs = []
      let tags = []
      _.each(this.node.tags, (t) => tags.push(t))
      //add children tags if not expanded
      if (!this.node.expanded) {
        //add all children, add the tag parent!
        let addTags = (n) => {
          _.each(n.tags, (t) => tags.push(t))
          _.each(n.children, (c) => addTags(c))
        }
        addTags(this.node)
      }
      tags = _.uniq(tags)
      _.each(tags, (tag) => {
        //console.log('looking for tag', tag, this.target)
        //find it in the first target tree
        let found = _.find(this.target.rows, (row) => (row.key === tag) || (row.code === tag))
        if (found) {
          //go up in tree if we are below a leaf
          if (found.parent.isLeaf) {
            found = found.parent
          }
          //if not expanded, show the parent tag
          if (!this.node.expanded) {
            found = found.parent
          }
          cs.push(found)
        }
      })
      cs = _.uniq(cs)
      return cs
    }
  }  
}
</script>

<style scoped>
.row {
  width: 100%;
  border-top: 1px solid #ddd;
  transition: all 1s ease-in;
  overflow-y: hidden;
}
.row.has-title-tip:has(.cntnt:hover) {
  overflow: visible;
  z-index: 30;
}
.row .single {
  cursor: pointer;
  position: relative;
}
.row .single .cntnt {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  width: 25%;
  max-width: 25%;
  padding-left: 4px;
  padding-right: 10px;
  min-height: 48px;
  box-sizing: border-box;
}
.row-title {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 48px;
}
.row-tip {
  display: none;
  position: absolute;
  left: 4px;
  top: 6px;
  z-index: 400;
  max-width: 70%;
  padding: 8px 12px;
  background: #22201e;
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
  border-radius: 4px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28);
  pointer-events: none;
  white-space: normal;
}
.cntnt:hover ~ .row-tip {
  display: block;
}
.row .single:hover {
  background-color: #eee;

}
.row .children {

}
.topped {
  position: absolute;
  left: 0; top:0; right: 0; bottom: 0;
  pointer-events: none;
}
.topped.columns {
  margin: 0;
}

.rela {
  position: relative;
}
.cells {
  position: relative;
  pointer-events: auto;
}
.spacer {
  width: 12px;
  display: inline-block;
  flex-shrink: 0;
}
.type-story, .type-course {
  display: inline-block;
  width: 48px;
  flex-shrink: 0;
}
.type-story::before, .type-course::before {
 font-family: "Font Awesome 5 Free";
 content: "\f518";
 display: inline-block;
 padding-right: 3px;
 vertical-align: middle;
 font-weight: 900;
 font-size: 32px;
 color: #22201e;
}
.type-story::before {
 content: "\f518";
}
.type-course::before {
 content: "\f51b";
}
.expander {
  margin-right: 8px;
  transition: all 0.7s linear;
  flex-shrink: 0;
  line-height: 48px;
}
.cntnt > a.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 8px;
  flex-shrink: 0;
  padding: 0;
  box-sizing: border-box;
}
.expander.expanded {
  transform: rotate(180deg);
}
.expand-enter-active, .expand-leave-active {
  transition: transform 0.7s ease-in-out, opacity 1s ease-out;
}
.expand-enter, .expand-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.expand-enter-to, .expand-leave {
  opacity: 1;
  transform: translateY(0);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}



.phase {
  display: inline-block;
  width: 48px;
  height: 40px;
  background-color: #7a756f;
  color: white;
  text-align: center;
  line-height: 32px;
  position: relative;
  padding-top: 8px;
  margin-right: 8px;
  cursor: pointer;
  transition: all 0.7s ease-in-out;
  flex-shrink: 0;
}

.phase.in:not(.out) {
  height: 48px;
}
.phase:not(.in):not(.out) {
  height: 48px;
}

.phase.in::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border-left: 24px solid transparent;
  border-right: 24px solid transparent;
  
  border-top: 8px solid white;
}
.phase.out::after {
  content: '';
  position: absolute;
  top: 100%; left: 0;
  width: 0;
  height: 0;
  border-left: 24px solid transparent;
  border-right: 24px solid transparent;
  
  border-top: 8px solid #7a756f;
  transition: all 0.7s ease-in-out;

}

.phase:hover {
  background-color: #22201e;
  color: white;
}
.phase:hover.out::after {
  border-top-color: #22201e;
}
.no-goals-info {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  font-style: italic;
  font-size: 13px;
  pointer-events: none;
}
</style>
